import cn from 'classnames';
import { Choice } from './Choice';
import { IsInline } from 'helpers';
import { QuestionProps } from 'types';

export function Choices({ choices, ...props }: QuestionProps) {
	const cln = cn({ 'col-12': !IsInline(choices) });
	const items = choices.map((choice, i) => <Choice {...props} {...choice} className={cln} key={i} />);
	return <>{items}</>;
}
